/* src/app/modules/print-cards/components/cards/backgrounds/index-cards-3x5/master-kush-strain-index-card-stack-background/master-kush-strain-index-card-stack-background.component.scss */
:host {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: stretch;
  box-sizing: border-box;
  padding: 8.25rem 0.25rem 0.25rem 0.25rem;
}
:host .main-content {
  flex: 1;
}
/*# sourceMappingURL=master-kush-strain-index-card-stack-background.component.css.map */
